// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { section, container } from 'styles/jss/original/base';

const styles = {
  section,
  container,
  textCenter: {
    textAlign: 'center'
  }
};

export default styles;
